/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {SegmentsJoin} from './SegmentsJoin';

/**
 * The SegmentsSegmentIdBody model module.
 * @module model/SegmentsSegmentIdBody
 * @version 1.0.0
 */
export class SegmentsSegmentIdBody {
  /**
   * Constructs a new <code>SegmentsSegmentIdBody</code>.
   * @alias module:model/SegmentsSegmentIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SegmentsSegmentIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SegmentsSegmentIdBody} obj Optional instance to populate.
   * @return {module:model/SegmentsSegmentIdBody} The populated <code>SegmentsSegmentIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SegmentsSegmentIdBody();
      if (data.hasOwnProperty('propertyId'))
        obj.propertyId = ApiClient.convertToType(data['propertyId'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('globalType'))
        obj.globalType = ApiClient.convertToType(data['globalType'], 'String');
      if (data.hasOwnProperty('query'))
        obj.query = ApiClient.convertToType(data['query'], 'String');
      if (data.hasOwnProperty('join'))
        obj.join = SegmentsJoin.constructFromObject(data['join']);
    }
    return obj;
  }
}

/**
 * @member {String} propertyId
 */
SegmentsSegmentIdBody.prototype.propertyId = undefined;

/**
 * @member {String} title
 */
SegmentsSegmentIdBody.prototype.title = undefined;

/**
 * @member {String} description
 */
SegmentsSegmentIdBody.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
SegmentsSegmentIdBody.prototype.enabled = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
SegmentsSegmentIdBody.TypeEnum = {
  /**
   * value: "email"
   * @const
   */
  email: "email",

  /**
   * value: "suppression"
   * @const
   */
  suppression: "suppression",

  /**
   * value: "data"
   * @const
   */
  data: "data"
};
/**
 * @member {module:model/SegmentsSegmentIdBody.TypeEnum} type
 */
SegmentsSegmentIdBody.prototype.type = undefined;

/**
 * Allowed values for the <code>globalType</code> property.
 * @enum {String}
 * @readonly
 */
SegmentsSegmentIdBody.GlobalTypeEnum = {
  /**
   * value: "none"
   * @const
   */
  none: "none",

  /**
   * value: "property"
   * @const
   */
  property: "property",

  /**
   * value: "global"
   * @const
   */
  global: "global"
};
/**
 * @member {module:model/SegmentsSegmentIdBody.GlobalTypeEnum} globalType
 */
SegmentsSegmentIdBody.prototype.globalType = undefined;

/**
 * @member {String} query
 */
SegmentsSegmentIdBody.prototype.query = undefined;

/**
 * @member {module:model/SegmentsJoin} join
 */
SegmentsSegmentIdBody.prototype.join = undefined;

